<template>
  <div class="swmain">
    <div class="swas">
      <Top @indexInfo="indexInfo"></Top>

      <!-- 内容区 -->
      <b-container class="m-0 p-0" fluid="fluid">
        <router-view :key="keys"></router-view>
      </b-container>

      <!-- 返回顶部 -->
      <div class="btnas">
        <img v-if="showBackToTop" @click="scrollToTop" class="btnimg" src="../static/goback.png" mode="" />
        <span class="textbtn">{{ $t("返回顶部") }}</span>
      </div>
    </div>

    <!-- 底部 -->
    <Footer />

  </div>
</template>
<script>
import Top from "./top/index.vue";
import Footer from "./aside/footer.vue";
export default {
  components: {
    Top,
    Footer
  },
  data() {
    return {
      fixedElementHeight: 40,
      showBackToTop: false, // 控制返回顶部按钮的显示
      indexData: null,
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScreenWidth);
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    rouls() {
      return this.$route.name;
    },
    keys() {
      return this.$route.fullPath;
    },
  },
  watch: {
    "this.$route"(newval, oldval) { },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {

    // 返回顶部
    scrollToTop() {
      var span = document.querySelector(".textbtn");
      if (span) {
        span.style.display = "none";
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    handleScroll() {
      const scrollTop =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (scrollTop > 300) {
        this.showBackToTop = true;
      } else {
        this.showBackToTop = false;
      }
    },

    // 获取当前信息
    indexInfo(data) {
      this.indexData = data;
    }
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.swmain {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.swas {
  min-height: calc(100vh - 150px);
}

.btnas {
  position: fixed;
  right: 30px;
  top: 70%;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: end;
  z-index: 1;
}

.btnimg {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  padding: 2px;
  overflow: hidden;
  cursor: pointer;
}

.textbtn {
  display: none;

  margin-top: 5px;
}

.btnas:hover .textbtn {
  display: block;
}
</style>
